export const USERS = 'users_list';
export const STOREDATA = "Firestore_Users_Data";
export const UPDATE_USER = 'updating_user_data';
export const LOGIN_ADMIN = 'Lgin_admin';
export const USERS_TEMP = 'USERS_TEMP';
